<template>
    <el-row type="flex" justify="center" align="middle">
    <el-col :span="12">
            <el-card style="height: 540px;">
    <el-form ref="outsiderFrom" :model="outsiderFrom" :rules="rules"  label-width="120px">
    <el-form-item :label="$t('applyoutsider.username', { msg: 'applyoutsider.username' })"  prop="username">
        <el-input v-model="outsiderFrom.username"></el-input>
    </el-form-item>
    <el-form-item :label="$t('applyoutsider.role', { msg: 'applyoutsider.role' })" prop="roleId">
        <el-select v-model="outsiderFrom.roleId" :placeholder="$t('applyoutsider.tipsrole', { msg: 'applyoutsider.tipsrole' })">
            <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
    </el-form-item>
    <el-form-item :label="$t('applyoutsider.password', { msg: 'applyoutsider.password' })" prop="password">
        <el-input v-model="outsiderFrom.password"></el-input>
    </el-form-item>
    <el-form-item :label="$t('applyoutsider.email', { msg: 'applyoutsider.email' })" prop="email">
        <el-input v-model="outsiderFrom.email"></el-input>
    </el-form-item>
    <el-form-item :label="$t('applyoutsider.companyName', { msg: 'applyoutsider.companyName' })" prop="companyName">
        <el-input v-model="outsiderFrom.companyName"></el-input>
    </el-form-item>
    <el-form-item :label="$t('applyoutsider.name', { msg: 'applyoutsider.name' })" prop="name">
        <el-input v-model="outsiderFrom.name"></el-input>
    </el-form-item>
   
    <el-form-item>
        <el-button type="primary" @click="onSubmit('outsiderFrom')">{{ $t('kbinfo.createNow', { msg: 'kbinfo.createNow' }) }}</el-button>
        <el-button @click="resetForm('outsiderFrom')">{{ $t('kbinfo.reset', { msg: 'kbinfo.reset' }) }}</el-button>
    </el-form-item>
    </el-form>
    </el-card>
    </el-col>

    </el-row>
    
</template>

<script>
 import { baseUrl_New } from '../../axios/urlconfig';
  import axios from 'axios';

export default {

    data() {
      return {
        
        outsiderFrom:{
        "companyName":'',
        "email":'',
        "name":'',
        "password":'',
        "roleId":null,
        "username":''
        },
        options: [{
             id:1,
          value: 4,
          label: '用户'
        }, {
             id:2,
          value: 5,
          label: '专家'
        }],
        rules: {
          name: [
            { required: true, message: '请输入真实名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请选择活动区域', trigger: 'blur' },
            { min: 3, max: 8, message: '长度在 3 到 8 个字符', trigger: 'blur'}
          ],
          username: [
            {  required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          email: [
            {  required: true, message: '请输入邮箱账户', trigger: 'blur' }
          ],
          roleId: [
            { required: true, message: '请至少选择用户身份', trigger: 'blur' }
          ],
          companyName: [
            {  required: true, message: '请输入公司/部门名称', trigger: 'blur' }
          ]
        }


      }
    },

    methods: {
       onSubmit(formName) { //新增用户
        this.$refs[formName].validate((valid) => {
          if (valid) {
        var that = this
        axios.post(baseUrl_New + '/out/addOut',{
            companyName:this.outsiderFrom.companyName,
            email:this.outsiderFrom.email,
            name:this.outsiderFrom.name,
            password:this.outsiderFrom.password,
            roleId:this.outsiderFrom.roleId,
            username:this.outsiderFrom.username
        }).then(resp=>{
          this.$message.success('succ。。。');
          this.resetForm('outsiderFrom');
        }).catch(err=>{
        console.log(err);
        });
          } 
        });
       
      },
      resetForm(outsiderFrom) {
        this.$refs[outsiderFrom].resetFields();
      },



    }

}
</script>

<style>

</style>